import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import queryString from 'query-string';
import ga from 'analytics';

import PluginService from 'services/PluginService.js';
import {fetchMyProfile} from 'actions/user.js';
import {fetchPlugins} from 'actions/plugins.js';
import {getPlugins} from 'reducers/plugins.js';
import Utils from 'utils/Utils.js';

import {initNavbarState} from 'actions/navbar.js';
import SurveyPageSyncContacts from './SurveyPageSyncContacts.js';
import {handleAuthenticationQueryString} from 'modules/plugins/PluginsContainer.js';

class SurveyPageSyncContactsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {error:null, busy:false, complete:false};
        this.onConnect = this.onConnect.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        console.log('SurveyPageSyncContactsContainer', this.props);
    }

    
    componentWillMount() {
        this.loadData();
        ga('send', 'pageview', { 'page': '/virtual/survey-sync-contacts' }); 
    }
    loadData() {
        this.setState({busy:true});
        var promise = Promise.resolve();
        var search = queryString.parse(this.props.location.search);
        if(search.auth) { //We are resuming from an oAuth redirection
            handleAuthenticationQueryString(this.props.location, this.props.history, promise);
            this.onSubmit(null, true);
        } else {
            promise.then(()=>(this.props.loadData()))
                   .catch((error)=> {
                       console.error('ERROR:');
                       console.error(error);
                    })
                    .then(()=>{
                        this.setState({busy:false});
                    });
        }
    }

    onConnect(plugin) {
        sessionStorage.oauth2callbackRedirect = this.props.location.pathname;
        this.props.preserveState();
        PluginService.connect(plugin)
            .catch((error)=>{
                console.error('Plugins.connect - error ', error);
                //Only hide loading overlay on error, otherwise we will be redirected away
                this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:false});
            });
    }

    onSubmit(event, val) {
        var key = val ? 'allow' : 'deny';
        var challengeAnswersByKey = this.getChallengeAnswersByKey();
        var challengeAnswer = challengeAnswersByKey[key];
        this.props.onSubmit(event, {challengeId:this.props.surveyPage.challenge.id, challengeAnswers:[challengeAnswer]});
    }
   
    getChallengeAnswersByKey() {
        return this.props.surveyPage.challenge.challengeAnswers.reduce((m,item)=>{
                                        m[item.key] = item;
                                        return m;
                                    },{});
    }

    render() {
        return <SurveyPageSyncContacts 
                         surveyPage={this.props.surveyPage}
                         onSkip={this.props.onSkip}
                         onSubmit={this.onSubmit}
                         error={this.state.error}
                         busy={this.state.busy}
                         complete={this.state.complete}
                         pluginsMap={this.props.pluginsMap}
                         onConnect={this.onConnect} />;
    }

}

const isAuthenticationPlugin = (plugin) => {
    return (plugin.tag==='google_plus');
}

const mapStateToProps = (state, ownProps) => {
    var plugins = getPlugins(state.plugins).filter(isAuthenticationPlugin);
    console.log('plugins: ', plugins);
    var pluginsMap = plugins.reduce((m,plugin)=>{
                    m[plugin.tag] = plugin;
                    return m;
                }, {});
    console.log('pluginsMap: ', pluginsMap);
    return {plugins:plugins, 
            pluginsMap:pluginsMap};
};
const mapDispatchToProps = (dispatch) => {
    return {
        loadData: () => dispatch(fetchPlugins({sync:true}, true)),
        dispatch: dispatch
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(translate('surveys')(SurveyPageSyncContactsContainer)));



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageSyncContactsContainer.js